import axios from "axios"
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;

const axiosApi = axios.create({
  baseURL: API_URL,
})

export function getAccessToken() {
  const getAuthUser = localStorage.getItem("authToken");
  return getAuthUser;
}

// Request Interceptor to add the Authorization header to all requests
axiosApi.interceptors.request.use(
  (request) => {
    const token = getAccessToken();
    if (token) {
      request.headers["Authorization"] = `Bearer ${token}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//new code end
axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;
    if (error.response) {
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        localStorage.removeItem("authToken");
        window.location.href = "/";
        return Promise.reject(error);
      }
      if (error.response.status === 403) {
        Swal.fire({
          icon: "error",
          title: "Access Denied",
          text: "You do not have permission to perform this action.",
        });
      }
    }

    return Promise.reject(error);
  }
);
export function isValidToken() {
  const getAuthUser = localStorage.getItem("authToken");
  var isValid = false;
  if (getAuthUser) {
    isValid = true;
  } else {
    localStorage.removeItem("authToken");
  }
  return isValid;
}
export async function get(url: string, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url: string, data: any, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data);
}

export async function put(url: string, data: any, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url: string, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}